import type { LucideIcon } from 'lucide-react';
import type * as React from 'react';
import { cn } from '../lib/cn.js';

export interface EmptyStateProps extends Omit<React.ComponentProps<'div'>, 'title'> {
  icon?: LucideIcon;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
}

/** État vide obligatoire de toute liste. */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  ...props
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex min-h-[320px] flex-col items-center justify-center rounded-xl border border-dashed border-card-border bg-card/50 p-8 text-center',
        className,
      )}
      {...props}
    >
      {Icon && (
        <div className="mb-4 rounded-full bg-accent-secondary/10 p-3 ring-1 ring-inset ring-accent-secondary/15">
          <Icon className="h-8 w-8 text-accent-secondary" />
        </div>
      )}
      <h3 className="mb-1.5 text-base font-semibold">{title}</h3>
      {description && <p className="mb-6 max-w-sm text-sm text-muted-foreground">{description}</p>}
      {action && <div>{action}</div>}
    </div>
  );
}
